module.exports = __webpack_public_path__ + "img/pethouse13.a357eb30.jpg";